// MB-I18N-2A — auth FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "auth.phone_label": "Numéro de téléphone",
  "auth.phone_placeholder": "5XX XX XX XX",
  "auth.continue": "Continuer",
  "auth.sms_notice": "Nous vous enverrons un code de vérification par SMS",
  "auth.otp_sent": "Code envoyé !",
  "auth.enter_code": "Entrez le code envoyé au",
  "auth.verify": "Vérifier",
  "auth.change_number": "Changer le numéro",
  "auth.dev_otp": "Code OTP (Mode Dev)",
  "auth.welcome": "Bienvenue !",
  "auth.setup_account": "Créons votre compte",
  "auth.your_name": "Votre prénom",
  "auth.enter_name": "Entrez votre prénom",
  "auth.get_started": "Commencer",
  "auth.welcome_offer": "🎁 Offre de bienvenue : 1 café offert après 1 000 DA dépensés !",
  "auth.invalid_otp": "Code invalide",
  "auth.registration_failed": "Échec de l'inscription",
  "auth.welcome_to": "Bienvenue chez SUPERKAWA® !",
  "auth.invalid_number": "Veuillez entrer un numéro valide",
  "auth.otp_send_failed": "Échec de l'envoi du code",
  "auth.enter_6_digit": "Veuillez entrer le code à 6 chiffres",
  "auth.enter_first_name": "Veuillez entrer votre prénom",
  "auth.staff_access": "Accès staff",
  "auth.rewards_order": "Rewards & Order",

  // MB-I18N-AUTH — LoginPage (staff + plateforme)
  "auth.staff_back_marketing": "Retour à superkawa.co",
  "auth.staff_footer": "Plateforme opérationnelle pour les établissements de restauration indépendants · © Superkawa 2026",
  "auth.staff_title": "SUPERKAWA OS",
  "auth.staff_platform_title": "SUPERKAWA Plateforme",
  "auth.staff_subtitle": "Connectez-vous à votre espace",
  "auth.staff_platform_subtitle": "Espace réseau · accès Super-Admin",
  "auth.staff_identifier_label": "Identifiant",
  "auth.staff_identifier_placeholder": "Ex : Taha01",
  "auth.staff_password_label": "Mot de passe",
  "auth.staff_password_show": "Afficher le mot de passe",
  "auth.staff_password_hide": "Masquer le mot de passe",
  "auth.staff_forgot_password": "Mot de passe oublié ?",
  "auth.staff_submit": "Connexion",
  "auth.staff_or": "ou",
  "auth.staff_register_cta": "Créer mon établissement",
  "auth.staff_not_partner": "Pas encore partenaire SUPERKAWA ?",
  "auth.staff_discover": "Découvrir les solutions →",
  "auth.staff_go_establishment": "Connexion espace établissement",
  "auth.staff_err_missing": "Veuillez renseigner email et mot de passe",
  "auth.staff_err_platform_only": "Accès réservé à la plateforme SUPERKAWA.",
  "auth.staff_err_too_many": "Trop de tentatives. Réessayez plus tard.",
  "auth.staff_err_blocked": "Connexion bloquée.",
  "auth.staff_err_invalid": "Identifiants incorrects",
  "auth.staff_forgot_toast": "Contactez votre référent Superkawa pour réinitialiser votre mot de passe.",

  // MB-I18N-AUTH — RegisterPage
  "auth.register_title": "Créer mon établissement",
  "auth.register_subtitle": "Votre établissement sera prêt en moins d'une minute.",
  "auth.register_guarantee_trial": "Essai gratuit 14 jours",
  "auth.register_guarantee_no_card": "Sans carte bancaire",
  "auth.register_guarantee_ready": "Votre boutique prête en quelques minutes",
  "auth.register_step_account": "Créez votre compte",
  "auth.register_step_email": "Vérifiez votre email",
  "auth.register_step_config": "Configurez votre boutique",
  "auth.register_name_label": "Nom du propriétaire",
  "auth.register_name_placeholder": "Karim Benali",
  "auth.register_email_label": "Email",
  "auth.register_email_placeholder": "contact@votre-etablissement.com",
  "auth.register_shop_label": "Nom de l'établissement",
  "auth.register_shop_placeholder": "Le Petit Kawa",
  "auth.register_password_label": "Mot de passe",
  "auth.register_password_placeholder": "8 caractères minimum",
  "auth.register_submit": "Créer mon établissement",
  "auth.register_reassurance": "Essai gratuit 14 jours · sans carte bancaire · votre boutique prête en quelques minutes",
  "auth.register_have_account": "Déjà un compte ?",
  "auth.register_login_link": "Se connecter",
  "auth.register_err_missing": "Veuillez remplir tous les champs",
  "auth.register_err_password_short": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.register_err_email_used": "Cette adresse email est déjà utilisée",
  "auth.register_err_too_many": "Trop d'inscriptions. Réessayez plus tard.",
  "auth.register_err_invalid": "Vérifiez les informations saisies",
  "auth.register_err_generic": "Une erreur est survenue. Réessayez.",
  "auth.register_success_title": "Vérifiez votre adresse email",
  "auth.register_success_sent_to": "Un email de confirmation a été envoyé à",
  "auth.register_success_access_1": "L'accès à votre espace SUPERKAWA OS sera disponible",
  "auth.register_success_access_highlight": "après vérification",
  "auth.register_dev_mode": "Mode développement",
  "auth.register_dev_notice": "Resend n'est pas encore branché. Utilisez ce bouton pour simuler le clic sur le lien email.",
  "auth.register_dev_verify": "Tester la vérification",
  "auth.register_already_verified": "Déjà vérifié ?",

  // MB-I18N-BACKEND-2A — messages d'erreur backend codés (rétrocompatibles)
  "auth.errors.invalid_credentials": "Identifiants incorrects",
  "auth.errors.email_not_verified": "Veuillez vérifier votre adresse email avant de vous connecter.",
  "auth.errors.register_name_required": "Le nom est requis",
  "auth.errors.register_email_invalid": "Adresse email invalide",
  "auth.errors.register_password_too_short": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.errors.register_email_exists": "Cette adresse email est déjà utilisée",
  "auth.errors.verify_token_missing": "Lien de vérification invalide : token manquant.",
  "auth.errors.verify_token_invalid": "Ce lien est invalide ou a expiré.",
  "auth.errors.verify_token_expired": "Ce lien de vérification a expiré.",
};
